import { render, staticRenderFns } from "./IncluirAtivo.vue?vue&type=template&id=e4743ea6&scoped=true&"
import script from "./IncluirAtivo.vue?vue&type=script&lang=js&"
export * from "./IncluirAtivo.vue?vue&type=script&lang=js&"
import style0 from "./IncluirAtivo.vue?vue&type=style&index=0&id=e4743ea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4743ea6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VForm,VImg,VRow,VSelect})
